<template>
  <div :style="{ width: `${width}%` }" class="flex-row-nowrap-start-start-center">
    <div style="width: 24px; height: 1px; background-color: #bbb"></div>
    <div style="flex-shrink: 1; margin-left: 8px; margin-right: 8px; color: #999">{{ title }}</div>
    <div style="flex-grow: 1; height: 1px; background-color: #bbb"></div>
  </div>
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    title: string
    width?: number
  }>(),
  {
    width: 100,
  }
)
</script>
<style scoped></style>
